// import { useApolloClient } from "@apollo/react-hooks";

const Logout = props => {
    const { router } = props;
    // const client = useApolloClient();
    
    // client.resetStore();
    localStorage.removeItem('xToken');
    // localStorage.removeItem('connectedTime');
    // localStorage.removeItem('expiresAt');
    // localStorage.removeItem('expiresToken2');
    router.push('/login');

    return null;
}

export default Logout;